import { makeStyles, Theme } from '@material-ui/core';

const COLORS = ['#88a4f1', '#6085ed', '#3867e8', '#2d52ba', '#16295d'];
const DELAY = '1.5s';
const WIDTH = 120;
const DOT_HEIGHT = 15;

export interface IStyledProps {
  width?: number;
  dotHeight?: number;
  color?: string;
}

const dot =
  (i: number) =>
  ({ color = COLORS[i - 1] }: IStyledProps) => ({
    animationDelay: `calc(${DELAY} / ${i + 1})`,
    backgroundColor: color,
  });

export const useStyles = makeStyles<Theme, IStyledProps>({
  '@keyframes bounceDelay': {
    '0%, 80%, 100%': { transform: 'scale(0)' },
    '40%': { transform: 'scale(1)' },
  },

  spinner: ({ width = WIDTH }) => ({
    width,
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    margin: '0 auto',
  }),

  big: {
    marginTop: '4rem !important',
    marginBottom: '4rem !important',
  },

  bounce: ({ dotHeight = DOT_HEIGHT }) => ({
    width: dotHeight,
    height: dotHeight,
    borderRadius: '100%',
    display: 'inline-block',
  }),

  // For some weird reason using props resolves in undefined in $bounceDelay
  animation: {
    animation: `$bounceDelay ${DELAY} infinite ease-in-out both`,
  },

  dot1: dot(1),
  dot2: dot(2),
  dot3: dot(3),
  dot4: dot(4),
  dot5: dot(5),
});
